import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventTokenCreated } from 'entities/Auth'
import { ConversationRoutes } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type RegisterMultiorgStore } from 'pages/register/pages/registerMultiorg/ui/RegisterMultiorg'

export const useEventTokenCreated = (store: RegisterMultiorgStore) => {
  const { websocket, authStore } = useEntitiesContext()

  const handler = (data: IResponseEventTokenCreated) => {
    if (store) store.setLoading(false)
    authStore.setSuccessAuthToken(data.token.access_token)
    window.stop()
    window.location.href = `/${ConversationRoutes.root}`
  }

  useEffect(() => websocket.on(WebsocketEvent.TokenCreated, handler), [])
}
